import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "../components";
import { stripHtml } from "../utils";

export default class ContentItem extends Component {
  static propsType = {
    title: PropTypes.string,
    content: PropTypes.string,
    nameButton: PropTypes.title,
    link: PropTypes.string,
  };

  render() {
    const { title, content, nameButton, link } = this.props;
    return (
      <div className="content-item-component">
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: stripHtml(content) }} />
        <Link to={link}>
          <Button ghost bordercolor="#ffb400">
            {nameButton}
          </Button>
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentItem.js